export default {
    title: "A jóváhagyó felettesed {email}"
}